import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";
import {
  createNewStoryboardList,
  updateStoryboardList,
  fetchAllStoryboardLists,
  deleteStoryboardList,
  invalidateStoryboardList,
  showStoryboardListCreateForm,
  selectStoryboardList,
  addStoryboardToList
} from "actions/storyboardList.jsx";
import styles from "./style.module.scss";
import cx from "classnames";
import { useHistory, Link, useParams } from "react-router-dom";
import { useDrop } from "react-dnd";
import { Button, Overlay, Popover, Form, FormCheck } from "react-bootstrap";

import { SuccessToast } from "components/Toast";
import { toast } from "react-toastify";
import { SMART_LISTS } from 'constants/smartLists';

export default function StoryboardSmartList(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { listId } = useParams();

  const showListCreateForm = useSelector((state) => _.get(state, "storyboardList.create.visible", false));
  const createdStoryboardList = useSelector((state) => _.get(state, "storyboardList.create.created", false));
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item.id"));
  const item = useSelector((state) => _.get(state, "storyboardList.item.id", false));

  const storyboardLists = useSelector((state) =>
    _.get(state, "storyboardList.items", [])
  );

  const addedToStoryboardList = useSelector((state) => _.get(state, "storyboardList.addStoryboard.added", false));
  const successMessage = useSelector((state) => _.get(state, "storyboardList.addStoryboard.successMessage", false));
  const error = useSelector((state) => _.get(state, "storyboards.error", null));

  const [{ canDrop }] = useDrop({
    accept: "storyboard",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    })
  })

  useEffect(() => {
    if (createdStoryboardList) {
      history.push(`/app/${workspace}/storyboards/folder/${item}`);
    }
  }, [createdStoryboardList]);


  useEffect(() => {
    if (error) {
      history.push(`/app/${workspace}/storyboards`);
    }
  }, [error]);

  useEffect(() => {
    dispatch(fetchAllStoryboardLists());
    dispatch(selectStoryboardList(listId));
  }, [listId]);

  useEffect(() => {
    if (addedToStoryboardList) {
      toast(
        <SuccessToast
          heading={`Success`}
          description={successMessage}
        />,
        {
          type: toast.TYPE.DEFAULT,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
    }
  }, [addedToStoryboardList]);

  return (
    <div
      id="smartFolderContainer"
      className={cx(styles.list, { [styles.sticky]: props.sticky })}
    >
      <CreateStoryboardList
        canDrop={canDrop}
      />

      {SMART_LISTS.map((list, index) => {
        var active = false;
        if (!list.id && !listId) {
          active = true;
        } else if (list.id == listId) {
          active = true;
        }
        return (
          <SmartStoryboardList
            key={index}
            index={index}
            list={list}
            active={active}
            canDrop={canDrop}
          />
        );
      })}

      {storyboardLists.map((list, index) => {
        return (
          <StoryboardList
            key={index}
            index={index}
            list={list}
            active={listId == list.id}
          />
        );
      })}

      {showListCreateForm && <CreateStoryboardListForm canDrop={canDrop} />}
    </div>
  );
}

function SmartStoryboardList(props) {

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item.id"));
  const ref = useRef(null);

  var url = `/app/${workspace}/storyboards`;

  if (props.list.id) {
    url = `/app/${workspace}/storyboards/folder/${props.list.id}`;
  }

  return (
    <Link
      to={url}
      ref={ref}
      id={props.list.id}
      className={cx(styles.storyboardList, { [styles.active]: props.active }, { [styles.disabled]: props.canDrop })}
      data-track-event="Mixpanel" data-track-props={props.list.id === "owned_by_me" ? "Owned by me Folder" : "All Folder"}
    >
      <span className={styles.name}>{props.list.name}</span>
    </Link>
  );
}

function CreateStoryboardList(props) {
  const dispatch = useDispatch();

  const handleShowStoryboard = () => {
    dispatch(showStoryboardListCreateForm())
  };

  return (
    <div
      className={cx(styles.storyboardList, styles.create, { [styles.disabled]: props.canDrop })}
      onClick={handleShowStoryboard}
    >
      <i className={cx('cleverstory-plus', styles.plusIcon)} />
      <span className={styles.name}>New Folder</span>
    </div>
  );
}

function CreateStoryboardListForm(props) {
  const dispatch = useDispatch();
  const [name, setName] = useState("");

  const creating = useSelector((state) => _.get(state, "storyboardList.create.creating", false));

  const handleSave = () => {
    if (name.trim() == '') {
      return;
    }
    dispatch(createNewStoryboardList({ name: name }));
  };

  const handleClose = () => {
    dispatch(invalidateStoryboardList());
  };

  const handleKeyPressed = (e) => {
    if (name.trim() == '') {
      return;
    }
    if (e.key === "Enter") {
      dispatch(createNewStoryboardList({ name: name }));
    }
  }

  return (
    <div className={cx(styles.storyboardList, styles.form, { [styles.disabled]: props.canDrop })}>

      {creating &&
        <div className={styles.loading}>
          <span className={styles.name}>Creating ...</span>
        </div>
      }

      <input
        value={name}
        placeholder="Folder Name"
        autoFocus
        className={styles.border}
        onChange={(e) => {
          setName(e.target.value);
        }}
        onKeyDown={handleKeyPressed}
      />

      <div className={styles.actions}>
        <button className={styles.action} onClick={handleSave}>
          <i className="cleverstory-tick"></i>
        </button>
        <button className={cx(styles.action, styles.cancel)} onClick={handleClose}>
          <i className="cleverstory-close"></i>
        </button>
      </div>
    </div>
  );
}

function StoryboardList(props) {
  const dispatch = useDispatch();

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item.id"));
  const editing = useSelector((state) => _.get(state, "storyboardList.item.edit.editing", false));
  const deleting = useSelector((state) => _.get(state, "storyboardList.item.delete.deleting", false));

  const ref = React.createRef(null);
  const [state, setState] = useState({
    editable: false,
    deleteView: false,
    name: "",
    show: false,
    target: null,
  })

  const global = _.get(props.list, 'global', false)

  useEffect(() => {
    setState(state => {
      return {
        ...state,
        target: null,
        editable: false
      }
    })
  }, [!props.active]);

  const handleDelete = (e) => {
    setState(state => {
      return {
        ...state,
        show: false,
        deleteView: true
      }
    })
    if (!state.show) {
      setState(state => {
        return {
          ...state,
          target: e.target,
        }
      })
    }
  }

  const handleActionClick = (e) => {
    if (!state.show) {
      setState(state => {
        return {
          ...state,
          target: e.target,
        }
      })
    }

    setState(state => {
      return {
        ...state,
        show: true
      }
    })
  }

  const handleSave = () => {
    setState(state => {
      return {
        ...state,
        editable: false
      }
    })
    dispatch(updateStoryboardList(props.list.id, { name: state.name }));
  };

  const handleClose = () => {
    setState(state => {
      return {
        ...state,
        editable: false
      }
    })
    dispatch(invalidateStoryboardList());
  };

  const handleEdit = () => {
    setState(state => {
      return {
        ...state,
        target: null,
        show: false,
        editable: true,
        name: props.list.name
      }
    });
  }

  const handleClosePopup = () => {
    setState(state => {
      return {
        ...state,
        target: null,
        deleteView: false,
      }
    });
  }

  const handleDeleteList = () => {
    setState(state => {
      return {
        ...state,
        deleteView: false
      }
    })

    dispatch(deleteStoryboardList(props.list.id));
  }

  const handleKeyPressed = (e) => {
    if (e.key === "Enter") {
      setState(state => {
        return {
          ...state,
          editable: false
        }
      })

      dispatch(updateStoryboardList(props.list.id, { name: state.name }));
    }
  }

  const truncate = (name) => {
    return name.length > 30 ? name.substring(0, 25) + "..." : name;
  }

  const handleDrop = (source, target, storyboard) => {
    dispatch(addStoryboardToList(source, target, storyboard));
  }

  var url = `/app/${workspace}/storyboards`;

  if (props.list.id) {
    url = `/app/${workspace}/storyboards/folder/${props.list.id}`;
  }

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "storyboard",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    drop(item) {
      handleDrop(item.sourceList, props.list, item.storyboard)
    },
  })

  const toggleGlobal = () => {
    dispatch(updateStoryboardList(props.list.id, { global: !global }))
  }

  return (
    <Link
      to={url}
      id={props.list.id}
      ref={drop}
      className={cx(styles.storyboardList, { [styles.active]: props.active || (isOver && canDrop) })}
      data-track-event="Mixpanel" data-track-props="Other Folders"
    >
      {deleting && props.active &&
        <div className={styles.loading}>
          <span className={styles.name}>Deleting ...</span>
        </div>
      }
      <div ref={ref} className={styles.ref}>
        {state.editable ? <input
          value={state.name}
          placeholder="Folder Name"
          className={styles.border}
          onChange={(e) => {
            setState(state => {
              return {
                ...state,
                name: e.target.value
              }
            })
          }}
          onKeyDown={handleKeyPressed}
        /> : <span className={styles.name}>{editing && props.active ? "updating" : truncate(props.list.name)}</span>}

        {props.list.canEdit && props.active && !state.editable &&
          <div onClick={handleActionClick} className={styles.moreActions}>
            <i className={cx('cleverstory-more', styles.iconMore)} />
          </div>
        }

        <Overlay
          show={state.show}
          target={state.target}
          placement="right-start"
          container={ref}
          rootClose
          onHide={() => {
            setState(state => {
              return {
                ...state,
                show: false
              }
            })
          }}
          containerPadding={20}
        >
          <Popover id="popover-contained" className={styles.actionsPopoverOverlay}>
            <Popover.Body>
              <div className={styles.pageSettingsPopoverContent}>
                <div className={styles.action}><span className={styles.name} onClick={handleEdit}>Rename</span></div>
                <div className={styles.action}><span className={styles.name} onClick={handleDelete}>Delete</span></div>
                <Form className={styles.form}>
                  <Form.Group controlId="indexing" className={cx(styles.smallGroup, styles.flexFormGroup)}>
                    <Form.Label className={cx(styles.inlineLabel, { [styles.active]: global })}>Global folder</Form.Label>
                    <Form.Check
                      type="switch"
                      className={styles.switchButton}
                    >
                      <FormCheck.Input isvalid onChange={toggleGlobal} checked={global} />
                    </Form.Check>
                  </Form.Group>
                </Form>
              </div>
            </Popover.Body>
          </Popover>
        </Overlay>

        {state.editable &&
          <div className={styles.actions}>
            <button className={styles.action} onClick={handleSave}>
              <i className="cleverstory-tick"></i>
            </button>
            <button className={cx(styles.action, styles.cancel)} onClick={handleClose}>
              <i className="cleverstory-close"></i>
            </button>
          </div>}

        <Overlay
          show={state.deleteView}
          target={state.target}
          placement="bottom-start"
          container={ref}
          rootClose
          onHide={() => {
            setState(state => {
              return {
                ...state,
                deleteView: false
              }
            })
          }}
          containerPadding={20}
        >
          <Popover id="popover-contained" className={styles.overlay}>
            <Popover.Header as="h3">Delete Folder: </Popover.Header>
            <Popover.Body>
              Deleting '{truncate(props.list.name)}' will only delete the folder and not the storyboards within it. These storyboards will be moved to 'All'. Sure you want to delete '{truncate(props.list.name)}' ?
              <div className={styles.buttonContainer}>
                <Button variant="secondary" onClick={handleClosePopup} className={styles.btnText}>Cancel</Button>
                <Button variant="primary" onClick={() => { handleDeleteList(props.list.id) }} className={styles.btnText}>Delete</Button>
              </div>
            </Popover.Body>
          </Popover>
        </Overlay>
      </div>
    </Link>
  );
}